export default function TrustBar() {
  return (
    <section className="bg-white py-12 border-b">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
          <div className="text-center">
            <div className="flex items-center justify-center mb-3">
              <i className="ri-star-fill text-4xl text-amber-500"></i>
              <i className="ri-star-fill text-4xl text-amber-500"></i>
              <i className="ri-star-fill text-4xl text-amber-500"></i>
              <i className="ri-star-fill text-4xl text-amber-500"></i>
              <i className="ri-star-fill text-4xl text-amber-500"></i>
            </div>
            <p className="text-3xl font-bold text-gray-900 mb-1">5.0</p>
            <p className="text-sm text-gray-600">150+ Reviews</p>
          </div>

          <div className="text-center">
            <div className="flex items-center justify-center w-12 h-12 mx-auto mb-3">
              <i className="ri-calendar-check-fill text-4xl text-red-600"></i>
            </div>
            <p className="text-3xl font-bold text-gray-900 mb-1">15+</p>
            <p className="text-sm text-gray-600">Years in Business</p>
          </div>

          <div className="text-center">
            <div className="flex items-center justify-center w-12 h-12 mx-auto mb-3">
              <i className="ri-shield-check-fill text-4xl text-red-600"></i>
            </div>
            <p className="text-3xl font-bold text-gray-900 mb-1">100%</p>
            <p className="text-sm text-gray-600">Licensed & Insured</p>
          </div>

          <div className="text-center">
            <div className="flex items-center justify-center w-12 h-12 mx-auto mb-3">
              <i className="ri-award-fill text-4xl text-red-600"></i>
            </div>
            <p className="text-3xl font-bold text-gray-900 mb-1">5000+</p>
            <p className="text-sm text-gray-600">Events Completed</p>
          </div>
        </div>
      </div>
    </section>
  );
}